var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 55.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f8bc19;}.cls-4{fill:#ea4437;}.cls-5{fill:#fff;}.cls-6{fill:#b9bbbd;}.cls-7{fill:#6d6e71;}.cls-8{fill:#37aa54;}.cls-9{fill:#567ebf;}.cls-10{clip-path:url(#clippath-1);}.cls-11{clip-path:url(#clippath-4);}.cls-12{clip-path:url(#clippath-3);}.cls-13{clip-path:url(#clippath-2);}.cls-14{clip-path:url(#clippath-7);}.cls-15{clip-path:url(#clippath-8);}.cls-16{clip-path:url(#clippath-6);}.cls-17{clip-path:url(#clippath-5);}.cls-18{clip-path:url(#clippath-9);}.cls-19{clip-path:url(#clippath-20);}.cls-20{clip-path:url(#clippath-21);}.cls-21{clip-path:url(#clippath-24);}.cls-22{clip-path:url(#clippath-23);}.cls-23{clip-path:url(#clippath-22);}.cls-24{clip-path:url(#clippath-25);}.cls-25{clip-path:url(#clippath-27);}.cls-26{clip-path:url(#clippath-28);}.cls-27{clip-path:url(#clippath-26);}.cls-28{clip-path:url(#clippath-29);}.cls-29{clip-path:url(#clippath-34);}.cls-30{clip-path:url(#clippath-35);}.cls-31{clip-path:url(#clippath-33);}.cls-32{clip-path:url(#clippath-32);}.cls-33{clip-path:url(#clippath-30);}.cls-34{clip-path:url(#clippath-31);}.cls-35{clip-path:url(#clippath-14);}.cls-36{clip-path:url(#clippath-13);}.cls-37{clip-path:url(#clippath-12);}.cls-38{clip-path:url(#clippath-10);}.cls-39{clip-path:url(#clippath-15);}.cls-40{clip-path:url(#clippath-17);}.cls-41{clip-path:url(#clippath-16);}.cls-42{clip-path:url(#clippath-19);}.cls-43{clip-path:url(#clippath-11);}.cls-44{clip-path:url(#clippath-18);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.99,
    y: 9.21,
    width: 124.03,
    height: 36.49
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m83.87,45.68h3.28c19.91,0,21.78,0,41.69-.02,4.34,0,8.13-3.8,8.15-8.12.03-6.71.01-13.43,0-20.14,0-1.75-.59-3.32-1.62-4.7-1.83-2.45-4.31-3.49-7.35-3.49-41.36.02-64.69.01-106.05.02-.71,0-1.42,0-2.13.14-3.82.71-6.82,4.18-6.84,8.04-.03,6.79-.02,13.57,0,20.36.01,2.06.82,3.85,2.23,5.34,1.75,1.84,3.94,2.6,6.48,2.6,20.72-.02,41.43-.01,62.15-.01"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m83.9,45.37h44.04c.55,0,1.09-.03,1.63-.11,4.08-.57,7.12-4.04,7.12-8.18,0-6.41,0-12.81,0-19.22,0-.6-.08-1.19-.21-1.76-.89-3.95-4.18-6.57-8.23-6.57H22.22c-.62,0-1.23.03-1.85.11-3.92.52-7.06,4.05-7.07,8.02-.02,6.62-.01,13.24,0,19.86,0,.98.22,1.94.62,2.84,1.5,3.35,4.13,5,7.76,5.01,20.74.01,41.48,0,62.23,0m-.03.31c-20.72,0-41.43-.01-62.15.01-2.54,0-4.73-.76-6.48-2.6-1.41-1.48-2.22-3.28-2.23-5.34-.03-6.79-.03-13.57,0-20.36.02-3.86,3.02-7.33,6.84-8.04.71-.13,1.42-.14,2.13-.14,41.36,0,64.69,0,106.05-.02,3.04,0,5.53,1.04,7.35,3.49,1.03,1.38,1.62,2.95,1.62,4.7,0,6.71.02,13.43,0,20.14-.02,4.32-3.82,8.11-8.15,8.12-19.91.02-21.78.01-41.69.02h-3.28"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m83.9,45.37c-20.74,0-41.48,0-62.22,0-3.63,0-6.26-1.66-7.76-5.01-.4-.89-.61-1.85-.62-2.84-.01-6.62-.02-13.24,0-19.86,0-3.97,3.15-7.5,7.07-8.02.62-.08,1.23-.11,1.85-.11,41.36,0,64.69,0,106.05,0,4.06,0,7.34,2.61,8.23,6.56.13.58.21,1.17.21,1.76,0,6.41,0,12.81,0,19.22,0,4.14-3.04,7.61-7.12,8.18-.55.08-1.09.11-1.63.11h-44.04"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m36.42,23.55c.07,2.93-2.32,5.79-5.78,5.8-3.38,0-5.83-2.78-5.8-5.83.03-3.18,2.59-5.74,5.79-5.75,3.25-.01,5.84,2.69,5.78,5.79"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.29,37.07c-1.86,0-3.39-1.53-3.39-3.39,0-1.86,1.54-3.39,3.39-3.39,1.87.01,3.39,1.53,3.38,3.39,0,1.87-1.52,3.38-3.39,3.38"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m43.2,26.45c0,1.59-1.31,2.9-2.9,2.9-1.59,0-2.9-1.3-2.91-2.9,0-1.6,1.3-2.91,2.91-2.91,1.59,0,2.9,1.31,2.89,2.91"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m43.19,23.08c0-.81.63-1.46,1.44-1.46.8,0,1.45.64,1.47,1.45.01.79-.65,1.46-1.45,1.46-.81,0-1.45-.63-1.46-1.44"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m59.35,24.62c.29-.98.58-1.96.87-2.95.1-.36.6-.58.92-.4.16.09.05.22.02.32-.37,1.17-.75,2.35-1.13,3.52-.04.1-.09.21-.1.31-.05.43-.26.6-.71.56-.29-.03-.43-.09-.52-.38-.27-.89-.57-1.78-.86-2.66-.05-.14-.05-.3-.21-.42-.32.98-.63,1.93-.94,2.9-.17.53-.46.7-.99.56-.13-.04-.15-.13-.19-.24-.45-1.38-.88-2.77-1.34-4.14-.09-.28,0-.31.25-.34.44-.05.65.09.77.54.25.97.55,1.92.86,2.98.25-.75.47-1.4.68-2.05.1-.31.23-.62.29-.94.08-.42.29-.57.73-.54.29.02.43.08.52.38.31,1.01.65,2,.98,3.01.03,0,.06,0,.09,0"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m85.13,24.74c.27-.92.51-1.73.75-2.53.07-.24.14-.47.2-.71.04-.17.13-.23.32-.24.7-.03.7-.04.48.64-.4,1.25-.81,2.5-1.2,3.76-.08.26-.21.36-.47.32-.25-.04-.56.13-.69-.31-.26-.91-.57-1.8-.87-2.7-.05-.14-.1-.28-.18-.54-.21.65-.39,1.18-.56,1.72-.17.52-.35,1.04-.5,1.57-.1.37-.37.24-.59.25-.21.01-.41.07-.51-.25-.42-1.38-.87-2.74-1.32-4.11-.08-.24-.06-.34.23-.35.61,0,.61-.02.78.56.28.96.56,1.92.87,2.97.37-1.12.71-2.15,1.03-3.18.08-.27.21-.38.49-.35.28.03.58-.1.7.35.25.91.58,1.8.87,2.7.04.11.08.22.16.44"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m93.49,21.79c.53-.57,1.16-.79,1.91-.67.8.13,1.35.74,1.36,1.57.02,1,0,2,.01,3.01,0,.4-.27.27-.45.27s-.46.12-.46-.27c.01-.81,0-1.62,0-2.43,0-.91-.32-1.32-1.03-1.34-.72-.01-1.3.56-1.32,1.34-.02.77-.03,1.54,0,2.31.02.4-.18.4-.47.4-.28,0-.48.02-.48-.39.02-2.05.02-4.09,0-6.14,0-.39.18-.4.48-.4.31,0,.48.03.47.41-.03.76.02,1.53-.04,2.33"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m103.66,21.91c.58-.69,1.21-.91,1.96-.79.81.13,1.35.74,1.37,1.57.02,1,0,2,.01,3.01,0,.4-.27.27-.45.27s-.47.12-.46-.27c.01-.81,0-1.62,0-2.43,0-.91-.32-1.32-1.03-1.34-.72-.02-1.3.56-1.32,1.34-.02.77-.03,1.54,0,2.31.02.4-.18.4-.47.4-.28,0-.48.03-.48-.39.02-2.04.02-4.09,0-6.14,0-.39.18-.4.48-.4.3,0,.48.03.47.41-.03.77.02,1.55-.09,2.45"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m73.97,21.31c-.55.55-1.07,1.09-1.6,1.59-.18.17-.17.29-.04.48.58.83,1.15,1.67,1.77,2.58-.38,0-.68,0-.99,0-.17,0-.22-.14-.29-.25-.37-.55-.74-1.1-1.09-1.65-.13-.21-.21-.25-.45-.07-.53.37-.43.89-.44,1.4,0,.64.09.55-.57.58-.29.01-.37-.09-.37-.37.01-1.38,0-2.75,0-4.13,0-.69.02-1.37,0-2.06-.02-.39.21-.37.47-.36.25,0,.48-.04.47.36-.02,1.13,0,2.25,0,3.38,0,.11.01.22.01.33.19.02.25-.13.34-.22.34-.34.72-.65,1-1.03.46-.6,1.04-.73,1.79-.57"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m109.9,23.06c.35,0,.71-.01,1.06,0,.24.01.33-.04.24-.3-.18-.55-.68-.86-1.4-.83-.53.02-1.06.44-1.18.92-.05.18.01.22.17.22.37,0,.74,0,1.11,0m.47.73c-.51,0-1.01.01-1.52,0-.31-.01-.35.13-.29.38.16.58.53.95,1.12,1.09.58.14,1.05-.06,1.44-.49.1-.1.12-.33.31-.26.22.07.43.18.62.31.12.08-.02.2-.07.28-.48.75-1.5,1.17-2.42,1-.97-.17-1.71-.87-1.92-1.81-.14-.64-.11-1.26.16-1.85.47-1.05,1.57-1.57,2.69-1.29,1.07.26,1.74,1.22,1.69,2.38-.01.24-.12.27-.31.27-.51,0-1.01,0-1.52,0"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m65.18,23.63c0-.99-.63-1.69-1.51-1.7-.88,0-1.54.71-1.54,1.68,0,.97.64,1.69,1.52,1.7.88.01,1.53-.71,1.54-1.68m.9.01c0,1.46-1.02,2.5-2.43,2.5-1.42,0-2.43-1.07-2.43-2.55,0-1.45,1.03-2.5,2.44-2.49,1.44,0,2.43,1.05,2.42,2.54"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m75.98,21.09c.68,0,1.26.23,1.68.79.16.21.17.35-.12.45-.28.1-.5.25-.77-.11-.3-.39-1.03-.42-1.44-.17-.39.24-.4.63.02.83.28.13.6.19.9.28.35.09.69.18,1,.36.81.48.89,1.55.16,2.15-.98.81-2.64.52-3.28-.57-.13-.23-.16-.35.14-.49.35-.16.53-.15.77.2.37.54,1.07.65,1.61.33.42-.24.44-.64.04-.91-.3-.21-.66-.25-1.01-.34-.36-.09-.72-.19-1.03-.4-.69-.46-.74-1.39-.12-1.94.35-.31.84-.47,1.45-.47"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m100.05,23.62c0-.4-.01-.8,0-1.2.01-.27-.07-.36-.34-.35-.45.01-.63-.28-.48-.69.08-.2.26-.13.39-.11.35.04.47-.11.43-.45-.02-.15,0-.3,0-.45,0-.58.16-.7.73-.58.18.04.17.15.17.27,0,.3.01.6,0,.91,0,.21.06.31.28.29.13-.01.28.02.41,0,.39-.06.49.1.48.47,0,.31-.13.36-.39.35-.77,0-.77,0-.77.77,0,.54,0,1.07,0,1.61.01.58.22.74.78.71.41-.02.3.38.41.59.13.25-.14.22-.25.25-1.21.24-1.93-.42-1.85-1.44.02-.31,0-.63,0-.95"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m89.91,23.58c0-.39-.01-.77,0-1.15.01-.27-.07-.36-.35-.35-.44.01-.63-.29-.47-.69.07-.19.24-.13.35-.11.4.05.52-.12.47-.49-.02-.13,0-.27,0-.41,0-.57.17-.7.74-.57.18.04.17.15.17.27,0,.3.01.6,0,.91,0,.21.07.3.29.29.13-.01.28.01.41,0,.39-.06.49.11.47.48-.01.27-.08.35-.35.35-.81,0-.81.01-.81.82,0,.52,0,1.04,0,1.57.01.57.22.74.78.7.41-.02.3.38.41.59.13.25-.14.22-.25.24-1.21.24-1.93-.42-1.85-1.44.02-.33,0-.66,0-.99"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m67.48,21.94c.47-.61,1-.91,1.71-.81.26.04.36.13.27.43-.12.35-.2.55-.68.49-.65-.08-1.23.56-1.24,1.26-.01.77-.03,1.53,0,2.3.02.43-.24.36-.5.37-.26,0-.46.03-.46-.36.02-1.3.02-2.61,0-3.91,0-.32.05-.47.42-.45.31.01.55.02.47.43-.01.05,0,.11,0,.25"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m87.53,23.62c0-.69.01-1.37,0-2.06-.01-.41.27-.29.48-.3.2,0,.44-.09.44.29-.02,1.37-.02,2.74,0,4.12,0,.37-.23.31-.43.29-.2-.01-.5.13-.48-.29.02-.69,0-1.37,0-2.06"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m88.01,18.99c.33,0,.63.3.63.64,0,.34-.29.63-.63.64-.36,0-.65-.29-.64-.65.01-.35.3-.62.64-.62"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m59.89,31.44c.49,0,.99,0,1.48,0,.23,0,.34.05.36.31.24,2.35-1.45,4.2-3.98,4-1.53-.13-2.68-.92-3.33-2.33-.61-1.34-.45-2.64.38-3.85,1.28-1.86,3.94-2.24,5.7-.85.25.19.29.34.03.53-.04.03-.08.07-.12.12-.23.31-.43.36-.79.1-.91-.67-2.24-.63-3.16.02-.95.67-1.4,1.89-1.11,3.05.29,1.15,1.19,1.96,2.35,2.1,1.58.19,2.55-.66,2.83-1.63.13-.45.13-.45-.33-.45-.62,0-1.23,0-1.85,0-.23,0-.31-.06-.31-.3.02-1.01-.1-.81.78-.83.36,0,.71,0,1.07,0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m77.07,33.25c0-.86-.61-1.57-1.35-1.57-.74,0-1.38.71-1.41,1.54-.02.8.65,1.53,1.4,1.53.74.01,1.36-.68,1.36-1.51m-.08,1.97c-1.05.81-2.23.7-3.13-.25-.88-.92-.88-2.43-.02-3.45.8-.95,2.03-1.08,3.14-.31-.08-.47.24-.36.48-.36.59,0,.59,0,.59.57,0,1.38,0,2.77,0,4.15-.01,1.23-.6,2.08-1.64,2.38-1.12.32-2.29-.12-2.86-1.06-.14-.24-.15-.4.15-.48.13-.04.26-.09.38-.15.17-.09.28-.07.41.1.48.65,1.01.83,1.67.6.53-.19.81-.66.82-1.42v-.3"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m89.77,29.95s-.07,0-.11,0c-.33.91-.66,1.81-.99,2.72-.05.14-.03.24.15.24.59,0,1.18,0,1.76,0,.17,0,.22-.07.17-.23-.33-.91-.66-1.82-.99-2.73m-.09,3.82h-.29q-1.11,0-1.5,1.07c-.03.08-.05.16-.08.23-.18.51-.51.68-1.01.53-.25-.07-.09-.24-.05-.35.5-1.34,1-2.69,1.51-4.03.27-.73.57-1.45.81-2.19.14-.43.46-.29.74-.31.25-.02.42.02.53.31.77,2.08,1.55,4.14,2.34,6.21.11.28.08.36-.25.38-.46.03-.76-.08-.83-.58-.01-.11-.06-.21-.1-.31q-.35-.96-1.37-.96h-.45Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m66.07,33.21c0-.85-.61-1.51-1.39-1.52-.81-.01-1.43.67-1.42,1.57,0,.85.64,1.52,1.4,1.5.81-.02,1.42-.69,1.41-1.55m-3.95-.02c0-1.45,1.1-2.5,2.58-2.5,1.44,0,2.53,1.12,2.52,2.57-.01,1.42-1.15,2.52-2.59,2.51-1.44-.01-2.51-1.12-2.5-2.58"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m81.62,32.74c-.06.36.07.36.27.28.57-.24,1.13-.48,1.7-.71.28-.11.2-.24.04-.36-.35-.28-.74-.35-1.15-.18-.48.19-.76.56-.86.98m1.65,3.03c-1.76-.01-2.84-1.15-2.81-2.66.03-1.43,1.14-2.48,2.55-2.42.92.04,1.92.89,2.1,1.76.04.22-.12.22-.23.27-.88.37-1.76.73-2.65,1.09-.47.19-.48.32-.1.65.51.43,1.35.36,1.87-.14.1-.09.16-.3.35-.17.24.15.52.26.68.5.05.08-.07.17-.13.24-.51.61-1.16.88-1.64.88"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m68.78,33.23c0,.85.65,1.53,1.44,1.53.75,0,1.4-.71,1.41-1.53.01-.83-.65-1.55-1.43-1.55-.8,0-1.42.69-1.42,1.55m1.44,2.54c-1.42,0-2.56-1.11-2.58-2.53-.02-1.42,1.11-2.55,2.55-2.55,1.45,0,2.55,1.08,2.57,2.52.01,1.42-1.11,2.56-2.54,2.56"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m112.67,33.3c-.26-.02-.52,0-.76.12-.33.18-.58.42-.53.83.04.36.4.64.81.69.5.05.91-.14,1.23-.51.21-.23.41-.52.28-.81-.12-.28-.47-.29-.75-.33-.1-.01-.19,0-.29,0m1.03,1.84c-.17.03-.24.18-.36.27-.64.47-1.32.48-2.01.14-.59-.3-.92-.8-.89-1.49.04-.77.63-1.36,1.55-1.47.46-.06.93-.06,1.38.08.11.03.24.15.33.02.09-.11.03-.27-.01-.39-.24-.65-1.15-.94-1.8-.58-.08.05-.18.09-.23.17-.21.31-.41.23-.67.06-.44-.3-.45-.29-.06-.65.86-.77,2.44-.73,3.22.09.34.36.46.8.47,1.28,0,.85,0,1.69,0,2.54,0,.18.1.46-.26.41-.24-.04-.66.2-.62-.36,0-.03-.02-.07-.04-.11"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m116.3,31.48c.55-.63,1.22-.86,2-.67.77.18,1.23.76,1.25,1.57.02.97-.01,1.94.01,2.91.01.4-.23.32-.45.31-.22,0-.47.1-.46-.31.02-.82.01-1.64,0-2.46,0-.83-.33-1.23-1.02-1.25-.72-.02-1.28.47-1.31,1.23-.03.81-.03,1.61,0,2.42.02.42-.21.37-.48.39-.3,0-.47,0-.47-.4.02-1.28.01-2.57,0-3.85,0-.27-.02-.49.37-.45.29.02.6-.04.51.42,0,.03.01.07.04.15"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m94.74,30.74c.92,0,1.51.24,1.94.81.14.19.14.33-.12.42-.29.11-.52.24-.8-.11-.31-.39-1.04-.41-1.44-.14-.36.24-.36.59.01.81.28.16.59.19.9.27.34.09.69.18,1,.36.83.48.91,1.57.16,2.17-.97.77-2.56.52-3.21-.53-.08-.13-.34-.35-.02-.45.23-.07.47-.52.77-.02.4.65,1.15.83,1.74.46.4-.24.41-.62.03-.89-.3-.21-.66-.26-1-.34-.35-.08-.69-.17-.99-.36-.74-.46-.81-1.42-.15-1.98.4-.34.88-.47,1.18-.46"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m98.93,30.74c.93,0,1.51.24,1.94.81.15.2.13.33-.12.42-.29.12-.52.23-.8-.11-.31-.39-1.04-.4-1.44-.14-.36.24-.36.6.02.81.28.16.59.19.9.27.34.09.69.18,1,.36.81.47.91,1.53.19,2.14-.96.81-2.62.54-3.26-.54-.07-.12-.3-.34,0-.41.23-.06.46-.5.75-.06.45.68,1.16.87,1.77.5.4-.24.41-.62.03-.89-.3-.21-.66-.26-1-.34-.35-.08-.69-.18-1-.36-.74-.46-.81-1.42-.15-1.98.4-.35.88-.47,1.18-.46"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m104.99,35.77c-.63-.03-1.28-.35-1.7-1.06-.12-.2-.11-.31.13-.43.35-.17.56-.19.81.19.36.54,1.07.64,1.61.33.42-.25.43-.64.02-.91-.3-.2-.66-.25-1-.34-.35-.08-.69-.18-.99-.37-.69-.44-.78-1.33-.2-1.9.79-.79,2.46-.68,3.13.21.08.11.28.24.1.42-.19.19-.67.25-.8.12-.44-.46-.99-.59-1.48-.36-.21.1-.39.22-.38.48,0,.26.2.39.41.46.46.14.93.24,1.38.39.5.17.91.45,1.02,1.01.12.64-.17,1.2-.78,1.52-.32.16-.7.25-1.28.24"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m79.95,31.86c0,1.14,0,2.27,0,3.4,0,.27-.08.35-.35.35-.81,0-.81.01-.81-.82,0-2.09,0-4.18,0-6.27,0-.3.08-.4.39-.39.77.01.77,0,.77.78v2.95Z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m108.12,33.28c0-.4-.02-.8,0-1.19.01-.29-.09-.38-.37-.37-.4.02-.62-.36-.44-.71.07-.15.22-.1.33-.09.41.06.54-.12.48-.51-.02-.13,0-.27,0-.41,0-.52.25-.69.76-.54.14.04.14.14.14.25,0,.31,0,.63,0,.94,0,.19.07.27.26.26.15-.01.3.02.45,0,.37-.06.46.11.45.46-.01.29-.09.37-.37.37-.79,0-.79,0-.79.8,0,.55-.01,1.1,0,1.64.01.51.25.69.76.64.43-.05.3.36.42.57.14.24-.11.23-.23.26-1.22.25-1.94-.42-1.86-1.41.02-.31,0-.63,0-.94"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m122.19,35.69c-1,0-1.5-.48-1.5-1.36,0-.74-.02-1.48,0-2.22,0-.32-.1-.41-.4-.39-.13.01-.35.09-.4-.09-.05-.2-.06-.45,0-.64.05-.15.27-.08.41-.07.28.02.4-.07.38-.37-.02-.27,0-.55,0-.82-.02-.39.26-.27.45-.27.19,0,.47-.11.45.27-.01.3,0,.6,0,.91-.01.22.08.3.29.28.12-.01.25,0,.37,0,.52,0,.51,0,.5.52,0,.24-.08.3-.31.3-.85.02-.85.03-.85.86,0,.51,0,1.01,0,1.52.01.57.22.72.79.7.41-.02.29.38.4.59.12.21-.11.2-.22.23-.16.04-.32.05-.36.05"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m102.55,33.29c0,.66-.02,1.32,0,1.97.02.36-.17.37-.42.35-.22-.02-.5.11-.49-.32.02-1.35.02-2.71,0-4.06,0-.44.3-.28.51-.3.24-.03.42-.02.41.32-.02.68,0,1.37,0,2.05"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m102.12,28.65c.33,0,.63.3.63.63s-.29.63-.62.64c-.37,0-.65-.28-.65-.65,0-.34.29-.62.64-.62"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleEn);
export default __webpack_public_path__ + "static/media/google-en.4fe3762a81d125780ad5f45aa47ef0ad.svg";
export { ForwardRef as ReactComponent };